/* Peculiar People bundle builder: product page tiers, Art File add-on, cart drawer add-on.
   Only steps in when a shopper picks 2+ items or ticks the Art File; a plain single
   add to cart still goes through Shrine's own product form untouched. Prices in the
   cart come from Shopify (cart sections), never from this file. */
(function () {
  if (window.ppBundleLoaded) return;
  window.ppBundleLoaded = true;

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/<[^>]*>/g, '');
  }

  // Shopify takes pct off each line and rounds the discount down to the cent.
  function unitPrice(price, pct) {
    return price - Math.floor((price * pct) / 100);
  }

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionsToRender() {
    var drawer = cartDrawer();
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function renderCart(state) {
    var drawer = cartDrawer();
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    } else {
      window.location.href = '/cart';
      return;
    }
    // No cartUpdate publish on purpose: Shrine's drawer item list answers it by loading
    // the full cart page section into the drawer (tested 11 Oct 2026). The render above
    // already refreshes the drawer and the cart icon count.
  }

  function postCart(url, body) {
    body.sections = sectionsToRender();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) throw new Error(json.description || json.message || 'Could not add to cart.');
        return json;
      });
    });
  }

  /* ---------- product page ---------- */

  class PPBundle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.section = this.dataset.section;
      this.format = this.dataset.moneyFormat;
      var v = this.querySelector('[data-pp-variants]');
      var o = this.querySelector('[data-pp-options]');
      this.variants = v ? JSON.parse(v.textContent) : [];
      this.optionNames = o ? JSON.parse(o.textContent) : [];
      this.qty = 1;

      this.querySelectorAll('.pp-tier input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => this.selectTier(parseInt(input.value, 10)));
      });

      // Keep prices and the "#1" summary in step with the main picker.
      var refresh = () => setTimeout(() => this.onVariantChange(), 60);
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, refresh);
        }
      } catch (e) {}
      var form = this.form();
      if (form) form.addEventListener('change', refresh);
      document.addEventListener('change', (e) => {
        if (e.target.closest && e.target.closest('variant-selects, .product-form__input')) refresh();
      });
    }

    form() {
      return document.getElementById('product-form-' + this.section);
    }

    currentVariant() {
      var form = this.form();
      var input = form && form.querySelector('input[name="id"]');
      var id = input ? parseInt(input.value, 10) : null;
      return this.variants.find((v) => v.id === id) || this.variants[0];
    }

    isActive() {
      var art = this.querySelector('[data-pp-art]');
      return this.qty > 1 || (art && art.checked);
    }

    selectTier(qty) {
      this.qty = qty;
      this.querySelectorAll('.pp-tier').forEach((tier) => {
        var on = parseInt(tier.dataset.qty, 10) === qty;
        tier.classList.toggle('is-selected', on);
        var picks = tier.querySelector('[data-pp-picks]');
        if (picks) {
          if (on) this.buildPicks(picks, qty);
          picks.hidden = !on;
        }
      });
    }

    onVariantChange() {
      var variant = this.currentVariant();
      if (!variant) return;
      this.querySelectorAll('.pp-tier').forEach((tier) => {
        var qty = parseInt(tier.dataset.qty, 10);
        var pct = parseInt(tier.dataset.pct, 10) || 0;
        var unit = unitPrice(variant.price, pct);
        var total = tier.querySelector('[data-pp-total]');
        var full = tier.querySelector('[data-pp-full]');
        var each = tier.querySelector('[data-pp-each]');
        if (total) total.textContent = money(unit * qty, this.format);
        if (full) full.textContent = money(variant.price * qty, this.format);
        if (each) each.textContent = money(unit, this.format);
      });
      var first = this.querySelector('.pp-tier.is-selected [data-pp-first]');
      if (first) first.textContent = variant.title;
    }

    buildPicks(container, qty) {
      var variant = this.currentVariant();
      var keep = Array.from(container.querySelectorAll('.pp-pick[data-index]')).map((row) =>
        Array.from(row.querySelectorAll('select')).map((s) => s.value)
      );
      container.innerHTML = '';
      var first = document.createElement('span');
      first.className = 'pp-pick pp-pick--first';
      first.innerHTML = '<span class="pp-pick__num">#1</span><span class="pp-pick__same"><span data-pp-first></span> <span class="pp-pick__hint">(chosen above)</span></span>';
      first.querySelector('[data-pp-first]').textContent = variant.title;
      container.appendChild(first);

      for (var i = 2; i <= qty; i++) {
        var row = document.createElement('span');
        row.className = 'pp-pick';
        row.dataset.index = i;
        var num = document.createElement('span');
        num.className = 'pp-pick__num';
        num.textContent = '#' + i;
        row.appendChild(num);
        var previous = keep[i - 2];
        this.optionNames.forEach((name, idx) => {
          var select = document.createElement('select');
          select.className = 'pp-pick__select';
          select.setAttribute('aria-label', name + ' for item ' + i);
          var values = [];
          this.variants.forEach((v) => {
            if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
          });
          values.forEach((value) => {
            var opt = document.createElement('option');
            opt.value = value;
            opt.textContent = value;
            select.appendChild(opt);
          });
          select.value = previous && previous[idx] ? previous[idx] : variant.options[idx];
          select.addEventListener('click', (e) => e.stopPropagation());
          select.addEventListener('change', () => this.checkRow(row));
          row.appendChild(select);
        });
        var warn = document.createElement('span');
        warn.className = 'pp-pick__warn';
        warn.hidden = true;
        warn.textContent = 'Sold out';
        row.appendChild(warn);
        container.appendChild(row);
        this.checkRow(row);
      }
    }

    rowVariant(row) {
      var chosen = Array.from(row.querySelectorAll('select')).map((s) => s.value);
      return this.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    }

    checkRow(row) {
      var v = this.rowVariant(row);
      var warn = row.querySelector('.pp-pick__warn');
      if (warn) warn.hidden = !!(v && v.available);
    }

    // Variant ids for items #2..N of the selected tier. Throws if one is sold out.
    tierIds() {
      if (this.qty < 2) return [];
      var tier = this.querySelector('.pp-tier.is-selected');
      var rows = tier ? tier.querySelectorAll('.pp-pick[data-index]') : [];
      var ids = [];
      for (var i = 0; i < rows.length; i++) {
        var v = this.rowVariant(rows[i]);
        if (!v || !v.available) throw new Error('Item #' + rows[i].dataset.index + ' is sold out in that colour and size. Pick another.');
        ids.push(v.id);
      }
      return ids;
    }

    artId() {
      var art = this.querySelector('[data-pp-art]');
      return art && art.checked ? parseInt(art.dataset.ppArt, 10) : null;
    }

    reset() {
      var art = this.querySelector('[data-pp-art]');
      if (art) art.checked = false;
    }
  }

  if (!customElements.get('pp-bundle')) customElements.define('pp-bundle', PPBundle);

  /* ---------- pair offer: tee page adds a hoodie, hoodie page adds a tee ---------- */

  /* Every product on the store, from templates/collection.pp-list.liquid. */
  var catalogPromise = null;
  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    var page = (n) => fetch('/collections/all?view=pp-list&page=' + n).then((r) => r.json());
    catalogPromise = page(1).then((first) => {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(page(n));
      return Promise.all(rest).then((pages) => pages.reduce((all, p) => all.concat(p.products), first.products));
    });
    return catalogPromise;
  }

  // The listings of one design in two inks as one product: every option's values in group
  // order (colours: each listing's own, listing by listing), every listing's variants, the
  // picked listing's handle and title, so the rest of the bundle treats it as one design.
  function joinInks(ps, handle) {
    if (ps.length === 1) return ps[0];
    var face = ps.find((p) => p.handle === handle) || ps[0];
    var options = face.options.map((opt, i) => {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = [];
      ps.forEach((p) => {
        var o = p.options[i];
        var own = o && typeof o !== 'string' ? o.values : p.variants.map((v) => v.options[i]);
        own.forEach((x) => { if (values.indexOf(x) === -1) values.push(x); });
      });
      if (!/colou?r/i.test(name) && typeof opt !== 'string') {
        // Sizes keep the face's order; any the face lacks follow.
        values = opt.values.concat(values.filter((x) => opt.values.indexOf(x) === -1));
      }
      return { name: name, position: i + 1, values: values };
    });
    var variants = [];
    ps.forEach((p) => p.variants.forEach((v) => {
      variants.push(Object.assign({}, v, { featured_image: v.featured_image || (p.featured_image ? { src: p.featured_image } : null) }));
    }));
    return Object.assign({}, face, { options: options, variants: variants });
  }

  // A design's short name from its product title: the quoted wordmark plus whatever sits
  // between it and the garment word, plus any suffix. 'Ultra-soft Oversized "Peculiar"
  // Collegiate Hoodie' -> 'Peculiar Collegiate'; 'Essential Heavyweight "Be Peculiar" Tee
  // - Español' -> 'Be Peculiar - Español'. The same design on another garment gets the same
  // name, which is how a page finds its own design in the other garment's list.
  function designName(title) {
    var m = title.match(/"([^"]+)"\s*(.*?)\s*\b(?:Tee|T-Shirt|Hoodie|Sweatshirt|Crewneck)\b\s*(.*)$/i);
    if (!m) return title;
    return [m[1], m[2], m[3]].filter(Boolean).join(' ');
  }
  var designKey = (title) => designName(title).toLowerCase();

  // Group products of one type: temple, map, or another design (Be Peculiar included).
  function toList(products, type) {
    var out = [];
    products.forEach((p) => {
      if (p.t !== type || !p.a) return;
      // An ink sibling (snippets/pp-ink.liquid) is the same design as its group's face listing,
      // reached from the face's colour row: listing it too would show the design twice.
      if (p.g.indexOf('listing:ink-sibling') !== -1) return;
      var tag = (prefix) => { var t = p.g.find((x) => x.indexOf(prefix) === 0); return t ? t.slice(prefix.length) : null; };
      var inParens = (p.n.match(/\(([^)]+)\)\s*$/) || [])[1];
      var temple = tag('temple:');
      var map = tag('map:');
      if (temple) out.push({ k: 'temple', s: temple, n: inParens || (temple === 'salt-lake' ? 'Salt Lake' : temple), h: p.h, i: p.i });
      else if (map) out.push({ k: 'map', s: map, n: inParens || (map === 'salt-lake-city' ? 'Salt Lake City' : map), h: p.h, i: p.i });
      else out.push({ k: 'other', s: designKey(p.n), n: designName(p.n), h: p.h, i: p.i });
    });
    return out.sort((a, b) => a.n.localeCompare(b.n));
  }

  class PPPair extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.format = this.dataset.moneyFormat;
      this.mode = this.dataset.mode;
      this.pct = parseInt(this.dataset.pct, 10) || 0;
      this.amountOff = parseInt(this.dataset.amountOff, 10) || 0;
      this.cache = {};
      this.product = null;
      // What the shopper picked for the other item, by option name. Size starts empty on
      // purpose: a preselected size gets shipped wrong when nobody looks at it.
      this.choice = {};
      this.swatchColours = {};
      (this.dataset.swatchSplit || '').split('|').forEach((pair) => {
        var m = pair.match(/^\s*(.+?)\s*=\s*(#[0-9a-f]{3,8})\s*$/i);
        if (m) this.swatchColours[m[1].toLowerCase()] = m[2];
      });
      this.selected = this.dataset.default === 'pair' ? 'pair' : 'single';
      // Resolves once the other item's colours and sizes have loaded, so an early
      // Add to cart waits for the bundle instead of adding the page's item alone.
      this.ready = new Promise((resolve) => { this._resolveReady = resolve; });
      this.body = this.querySelector('[data-pp-pair-body]');
      this.place = this.querySelector('[data-pp-place]');
      this.options = this.querySelector('[data-pp-options]');
      var main = this.querySelector('[data-pp-main]');
      this.mainVariants = main ? JSON.parse(main.textContent) : [];
      // The page's own pickers (snippets/pp-mine.liquid): one panel, moved into the
      // selected card. A pick sets the theme's hidden picker, the variant's record.
      // Undo the fallback in blocks/pp-pair.liquid if this script arrived late.
      document.documentElement.classList.remove('pp-no-bundle');
      this.mine = this.querySelector('[data-pp-mine]');
      if (this.mine) {
        this.mine.querySelectorAll('[data-pp-mine-opt] [role="radio"]').forEach((b) => {
          b.addEventListener('click', () => {
            if (b.getAttribute('aria-disabled') === 'true') return;
            this.pickMine(b.closest('[data-pp-mine-opt]').dataset.ppMineName, b.dataset.value);
          });
        });
        this.paintMine();
      }

      // Option 1 = just this product, option 2 = this product plus the other one.
      // The page's own Add to cart adds whichever is selected.
      this.querySelectorAll('input[type="radio"]').forEach((r) => {
        r.addEventListener('change', () => this.select(r.value));
      });

      var refresh = () => setTimeout(() => this.update(), 80);
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, refresh);
      } catch (e) {}
      // "Add another" (Evan, 3 Nov 2026): after a "Just the tee" add, the drawer offers one
      // tap back to this card with the picks kept, for a second one in any size or colour.
      // Shrine's form publishes cartUpdate (source product-form) after its own add.
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => this.onCartUpdate(e));
        }
      } catch (e) {}
      document.addEventListener('change', (e) => {
        if (e.target.closest && e.target.closest('variant-selects, .product-form__input')) refresh();
      });

      // A page that is neither a temple nor a map finds its own design by name.
      this.myKind = this.dataset.myKind === 'temple' || this.dataset.myKind === 'map' ? this.dataset.myKind : 'other';
      this.mySlug = this.myKind === 'other' ? designKey(this.dataset.myTitle || '') : this.dataset.mySlug;

      loadCatalog().then((all) => this.init(toList(all, this.dataset.wantType))).catch(() => this.unavailable());
    }

    // No list, no bundle: hide option 2 and fall back to the page's item alone.
    unavailable() {
      this.querySelector('[data-opt="pair"]').hidden = true;
      var single = this.querySelector('input[value="single"]');
      if (single) single.checked = true;
      this.select('single');
      this._resolveReady();
    }

    select(value) {
      this.selected = value;
      this.querySelectorAll('.pp-offer').forEach((card) => card.classList.toggle('is-selected', card.dataset.opt === value));
      this.body.hidden = value !== 'pair';
      this.placeMine(value);
      this.label();
    }

    init(list) {
      this.list = list;
      var mine = this.list.find((x) => x.k === this.myKind && x.s === this.mySlug);
      var start = mine || this.list.find((x) => x.k === 'temple' && x.s === 'salt-lake') || this.list[0];
      if (!start) { this.unavailable(); return; }
      this.kind = start.k;

      // One button per design group present in the list, so a new line shows up by itself.
      var KINDS = [['temple', 'Temple'], ['map', 'Map'], ['other', 'Other designs']];
      var kindsEl = this.querySelector('[data-pp-kinds]');
      KINDS.forEach(([k, label]) => {
        if (!this.list.some((x) => x.k === k)) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pp-seg__btn';
        b.dataset.kind = k;
        b.textContent = label;
        b.addEventListener('click', () => {
          if (k === this.kind) return;
          this.kind = k;
          var same = this.list.find((x) => x.k === k && x.s === this.mySlug);
          this.fillPlaces(same ? same.h : null);
        });
        kindsEl.appendChild(b);
      });
      if (kindsEl.children.length < 2) kindsEl.hidden = true;
      this.place.addEventListener('change', () => this.load(this.place.value));
      this.fillPlaces(start.h);
    }

    fillPlaces(handle) {
      this.querySelectorAll('.pp-seg__btn').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.kind === this.kind)));
      var label = this.querySelector('[data-pp-place-label]');
      if (label) label.textContent = { temple: 'Temple', map: 'Map' }[this.kind] || 'Design';
      this.place.innerHTML = '';
      var items = this.list.filter((x) => x.k === this.kind);
      items.forEach((x) => {
        var o = document.createElement('option');
        o.value = x.h;
        o.textContent = x.n;
        this.place.appendChild(o);
      });
      if (!items.length) return;
      this.place.value = handle && items.some((x) => x.h === handle) ? handle : items[0].h;
      this.load(this.place.value);
    }

    // Loads the picked design. Retries twice; while it loads, Add to cart waits, and if it
    // never loads, Add to cart refuses rather than adding the previously loaded design
    // (that happened when a lookup failed: the list said Provo, the cart got Logan).
    load(handle) {
      var done = (p) => {
        if (this.place.value !== handle) return;
        this.product = p;
        this.pending = null;
        this.failed = null;
        this.buildOptions();
        this._resolveReady();
      };
      if (this.cache[handle]) return done(this.cache[handle]);
      var get = (h, left) => fetch('/products/' + h + '.js')
        .then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .catch((e) => {
          if (left <= 0) throw e;
          return new Promise((res) => setTimeout(res, 900 * (3 - left))).then(() => get(h, left - 1));
        });
      // A design in two inks is two listings (snippets/pp-ink.liquid): load both and offer
      // their colours as one row. Each colour's variants stay their own listing's, so the
      // cart line is always the right ink.
      var entry = this.list.find((x) => x.h === handle);
      var group = entry && entry.i && entry.i.length > 1 && entry.i.indexOf(handle) !== -1 ? entry.i : [handle];
      this.failed = null;
      this.pending = handle;
      this.pendingPromise = Promise.all(group.map((h) => get(h, 2)))
        .then((ps) => joinInks(ps, handle))
        .then((p) => { this.cache[handle] = p; done(p); })
        .catch(() => {
          if (this.place.value !== handle) return;
          this.pending = null;
          if (!this.product) { this.unavailable(); return; }
          this.failed = handle;
          this.update();
        });
      this.update();
    }

    // True while the design in the list is not the one loaded (still loading, or failed).
    stale() {
      return !this.product || this.place.value !== this.product.handle;
    }

    form() {
      return document.getElementById('product-form-' + this.dataset.section);
    }

    mainVariant() {
      var form = this.form();
      var input = form && form.querySelector('input[name="id"]');
      var id = input ? parseInt(input.value, 10) : null;
      return this.mainVariants.find((x) => x.id === id) || this.mainVariants[0] || null;
    }

    // Sets the theme's own picker and lets it do the rest (variant id, price, photos, URL).
    // Queried fresh each time: the theme can re-render its picker after a change.
    pickMine(name, value) {
      var vs = document.querySelector('variant-selects[data-section="' + this.dataset.section + '"]') ||
        document.querySelector('variant-selects');
      if (!vs) return;
      var names = [name, 'options[' + name + ']'];
      var radio = Array.from(vs.querySelectorAll('input[type="radio"]'))
        .find((r) => names.indexOf(r.name) !== -1 && r.value === value);
      var select = Array.from(vs.querySelectorAll('select')).find((s) => names.indexOf(s.name) !== -1);
      var target = radio || select;
      if (!target) return;
      if (radio) radio.checked = true;
      else select.value = value;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Marks the current variant's values; a size sold out in the chosen colour greys out.
    paintMine() {
      var main = this.mine && this.mainVariant();
      if (!main) return;
      this.mine.querySelectorAll('[data-pp-mine-opt]').forEach((group) => {
        var idx = parseInt(group.dataset.ppMineOpt, 10);
        var chosen = main.options[idx];
        var colour = group.classList.contains('pp-opt--colour');
        group.querySelector('[data-pp-mine-value]').textContent = chosen;
        group.querySelectorAll('[role="radio"]').forEach((b) => {
          b.setAttribute('aria-checked', String(b.dataset.value === chosen));
          if (colour) return;
          var free = this.mainVariants.some((v) => v.available && v.options[idx] === b.dataset.value &&
            v.options.every((o, i) => i === idx || o === main.options[i]));
          b.setAttribute('aria-disabled', String(!free));
        });
      });
    }

    // One panel, moved into whichever card is selected.
    placeMine(value) {
      if (!this.mine) return;
      var slot = this.querySelector('[data-pp-mine-slot="' + (value === 'pair' ? 'pair' : 'single') + '"]');
      if (slot && this.mine.parentNode !== slot) slot.appendChild(this.mine);
      var single = this.querySelector('[data-pp-single-body]');
      if (single) single.hidden = value === 'pair';
    }

    isColour(name) { return /colou?r/i.test(name); }

    buildOptions() {
      var p = this.product;
      var lead = p.variants.find((v) => v.available) || p.variants[0];
      this.optionNames = p.options.map((opt) => (typeof opt === 'string' ? opt : opt.name));
      this.options.innerHTML = '';
      this.optionNames.forEach((name, idx) => {
        var opt = p.options[idx];
        var values = typeof opt === 'string' ? [] : opt.values.slice();
        if (!values.length) p.variants.forEach((v) => { if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]); });
        var colour = this.isColour(name);
        // Keep the shopper's pick when the new design has it. Colour falls back to the
        // lead colour; size stays empty until they choose one.
        if (values.indexOf(this.choice[name]) === -1) this.choice[name] = colour || values.length === 1 ? lead.options[idx] : null;
        if (values.length < 2) return;

        var group = document.createElement('div');
        group.className = 'pp-opt' + (colour ? ' pp-opt--colour' : ' pp-opt--size');
        group.dataset.name = name;
        var label = document.createElement('div');
        label.className = 'pp-opt__label';
        label.id = 'pp-opt-' + this.dataset.section + '-' + idx;
        label.innerHTML = '<span></span> <span class="pp-opt__value"></span>';
        label.firstChild.textContent = name;
        var head = document.createElement('div');
        head.className = 'pp-opt__head';
        head.appendChild(label);
        if (/size/i.test(name)) {
          // The same button as snippets/pp-size-button.liquid; its chart follows the
          // design picked (paintSizeButton), so any garment paired gets its own chart.
          var mineBtn = this.querySelector('[data-pp-mine] .pp-size-btn');
          if (mineBtn) {
            var guide = mineBtn.cloneNode(true);
            guide.dataset.ppSizeOther = '';
            head.appendChild(guide);
          }
        }
        group.appendChild(head);
        var list = document.createElement('div');
        list.className = colour ? 'pp-swatches' : 'pp-chips';
        list.setAttribute('role', 'radiogroup');
        list.setAttribute('aria-labelledby', label.id);
        values.forEach((value) => {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'radio');
          b.dataset.value = value;
          if (colour) {
            b.className = 'pp-swatch';
            b.setAttribute('aria-label', value);
            b.title = value;
            var hex = this.swatchColours[value.toLowerCase()];
            if (hex) b.style.setProperty('--pp-swatch', hex);
            else { b.classList.add('pp-swatch--text'); b.textContent = value; }
          } else {
            b.className = 'pp-chip';
            b.textContent = value;
          }
          b.addEventListener('click', () => {
            if (b.getAttribute('aria-disabled') === 'true') return;
            this.choice[name] = value;
            group.classList.remove('is-missing');
            this.update();
          });
          list.appendChild(b);
        });
        group.appendChild(list);
        this.options.appendChild(group);
      });
      this.paintSizeButton();
      var nameEl = this.querySelector('[data-pp-pair-name]');
      var picked = this.list.find((x) => x.h === p.handle);
      var what = this.mode === 'add-tee' ? 'tee' : 'hoodie';
      if (nameEl) nameEl.textContent = picked ? picked.n + ' ' + what : what.charAt(0).toUpperCase() + what.slice(1);
      this.update();
    }

    // Points the added item's "Size chart" button at that item's garment (assets/pp-size.js
    // titles it, or hides it when the garment has no chart).
    paintSizeButton() {
      var b = this.options.querySelector('[data-pp-size-other]');
      if (!b || !this.product) return;
      var size = window.ppSizeChart;
      b.dataset.ppSizeChart = (size && size.garmentOf(this.product.type || '', this.product.tags)) || '';
      if (size) size.paint(b.parentNode);
    }

    // Variants that fit everything picked so far (empty picks match anything).
    matching(extra) {
      if (!this.product) return [];
      var want = Object.assign({}, this.choice, extra || {});
      return this.product.variants.filter((v) => this.optionNames.every((n, i) => !want[n] || v.options[i] === want[n]));
    }

    // The full variant, or null while a pick (the size) is still missing.
    variant() {
      if (!this.product || this.optionNames.some((n) => !this.choice[n])) return null;
      return this.matching()[0] || null;
    }

    paint() {
      this.options.querySelectorAll('.pp-opt').forEach((group) => {
        var name = group.dataset.name;
        var colour = group.classList.contains('pp-opt--colour');
        var chosen = this.choice[name];
        var value = group.querySelector('.pp-opt__value');
        value.textContent = chosen ? chosen : 'Pick a size';
        value.classList.toggle('is-empty', !chosen);
        group.querySelectorAll('[role="radio"]').forEach((b) => {
          var on = b.dataset.value === chosen;
          b.setAttribute('aria-checked', String(on));
          // Grey out a size that is sold out in the chosen colour (colours never grey out).
          if (!colour) {
            var sel = {}; sel[name] = b.dataset.value;
            var free = this.matching(sel).some((v) => v.available);
            b.setAttribute('aria-disabled', String(!free));
          }
        });
      });
    }

    // Add to cart names the bundle and its total while the bundle is selected.
    label() {
      var form = this.form();
      // After an add the theme rebuilds the button's label as one plain
      // .main-atc__label__text (no line-1, no span), so fall back to whichever is there and remember the original text on this element.
      var btn = form && form.querySelector('[name="add"]');
      var line = btn && (btn.querySelector('.main-atc__label__line-1') || btn.querySelector('.main-atc__label__text'));
      if (!line) return;
      var span = line.querySelector(':scope > span') || line;
      if (this.ppOriginal === undefined) this.ppOriginal = span.dataset.ppOriginal || span.textContent.trim();
      span.dataset.ppOriginal = this.ppOriginal;
      var total = this.querySelector('[data-pp-pair-now]');
      var pair = this.selected === 'pair' && this.product && !this.querySelector('[data-opt="pair"]').hidden;
      var text = pair ? 'Add both · ' + total.textContent.trim()
        : this.added ? 'Add another ' + (this.dataset.meOne || 'one') : span.dataset.ppOriginal;
      if (span.textContent.trim() !== text) span.textContent = text;
    }

    /* ---- Add another ---- */

    onCartUpdate(e) {
      var d = e && e.cartData;
      var mine = d && d.variant_id && this.mainVariants.some((v) => v.id === d.variant_id);
      if (e && e.source === 'product-form' && this.selected === 'single' && mine) {
        this.added = d.variant_title || (d.options_with_values || []).map((o) => o.value).join(' / ') || 'yes';
        this.paintAdded();
        this.label();
      }
      if (!this.added) return;
      // The drawer re-renders its body after the add, and the theme resets the button's
      // label when its add finishes: place the button and relabel once both have run.
      [60, 600, 1500].forEach((ms) => setTimeout(() => { this.offerAnother(); this.label(); }, ms));
    }

    paintAdded() {
      var card = this.querySelector('[data-opt="single"]');
      var detail = card && card.querySelector('[data-pp-single-body]');
      if (!detail) return;
      var note = detail.querySelector('.pp-added');
      if (!note) {
        note = document.createElement('p');
        note.className = 'pp-added';
        note.setAttribute('role', 'status');
        detail.prepend(note);
      }
      note.textContent = '';
      var strong = document.createElement('strong');
      strong.textContent = 'In your cart: ' + (this.added === 'yes' ? '1' : this.added);
      note.appendChild(strong);
      note.appendChild(document.createTextNode('. Pick a size or colour for the next one.'));
    }

    offerAnother() {
      var drawer = cartDrawer();
      var body = drawer && drawer.querySelector('.cart-drawer__body');
      if (!body || body.querySelector('.pp-another')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pp-another';
      b.textContent = '+ Add another ' + (this.dataset.meOne || 'one');
      b.addEventListener('click', () => this.backToCard(drawer));
      var items = body.querySelector('cart-drawer-items');
      if (items) items.after(b); else body.appendChild(b);
    }

    backToCard(drawer) {
      if (drawer && typeof drawer.close === 'function') drawer.close();
      if (this.selected !== 'single') {
        var single = this.querySelector('input[value="single"]');
        if (single) single.checked = true;
        this.select('single');
      }
      var card = this.querySelector('[data-opt="single"]');
      if (!card) return;
      setTimeout(() => {
        var rows = card.querySelectorAll('[data-pp-mine-opt]');
        var size = [...rows].find((r) => /size|talla/i.test(r.dataset.ppMineName || '')) || rows[rows.length - 1];
        (size || card).scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (!size) return;
        size.classList.remove('pp-flash');
        void size.offsetWidth;
        size.classList.add('pp-flash');
      }, 350);
    }

    // Fixed amount off when set (Winter Package from 13 Oct 2026), else pct% rounded down.
    off(price) {
      if (this.amountOff > 0) return Math.max(0, price - this.amountOff);
      return price - Math.floor((price * this.pct) / 100);
    }

    set(sel, text) {
      this.querySelectorAll(sel).forEach((el) => { el.textContent = text; });
    }

    update() {
      var main = this.mainVariant();
      if (main) {
        this.set('[data-pp-single-price]', money(main.price, this.format));
        this.set('[data-pp-main-title]', main.title);
        if (main.img) this.querySelectorAll('[data-pp-main-img]').forEach((img) => { img.src = main.img; });
      }
      this.paintMine();
      if (this.added) this.label();
      var full = this.variant();
      var err = this.querySelector('[data-pp-pair-error]');
      var what = this.mode === 'add-tee' ? 'tee' : 'hoodie';
      this.classList.toggle('is-loading', !!this.pending);
      if (this.failed && this.failed === this.place.value) {
        err.hidden = false;
        err.textContent = "Couldn't load that " + what + '. Check your connection and try again.';
      } else {
        err.hidden = !(full && !full.available);
        err.textContent = 'That ' + what + ' is sold out in that colour and size. Pick another.';
      }
      if (!this.product) return;
      this.paint();
      // Before a size is picked, price and photo come from the chosen colour.
      var v = full || this.matching().find((x) => x.available) || this.matching()[0];
      var src = (v && v.featured_image && v.featured_image.src) || this.product.featured_image;
      if (src) {
        var url = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=360';
        this.querySelectorAll('[data-pp-pair-img], [data-pp-pair-thumb]').forEach((img) => {
          if (img.getAttribute('src') === url) return;
          img.classList.add('is-swapping');
          img.onload = () => img.classList.remove('is-swapping');
          img.src = url;
          img.hidden = false;
        });
      }
      if (!v || !main) return;
      // The Winter Package takes pct% off the tee, whichever side of the pair it is on.
      var meWas = main.price, otherWas = v.price;
      var meNow = this.mode === 'add-hoodie' ? this.off(meWas) : meWas;
      var otherNow = this.mode === 'add-tee' ? this.off(otherWas) : otherWas;
      this.set('[data-pp-me-now]', money(meNow, this.format));
      this.set('[data-pp-me-was]', money(meWas, this.format));
      this.set('[data-pp-other-now]', money(otherNow, this.format));
      this.set('[data-pp-other-was]', money(otherWas, this.format));
      this.set('[data-pp-pair-now]', money(meNow + otherNow, this.format));
      this.set('[data-pp-pair-was]', money(meWas + otherWas, this.format));
      this.set('[data-pp-pair-save]', money(meWas + otherWas - meNow - otherNow, this.format));
      this.label();
    }

    isActive() {
      return this.selected === 'pair';
    }

    item() {
      var what = this.mode === 'add-tee' ? 'tee' : 'hoodie';
      if (this.stale()) throw new Error("Couldn't load that " + what + '. Check your connection and try again.');
      var v = this.variant();
      if (!v) {
        var missing = this.options.querySelector('.pp-opt--size') || this.options.querySelector('.pp-opt');
        if (missing) {
          missing.classList.add('is-missing');
          missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        var err = this.querySelector('[data-pp-pair-error]');
        err.textContent = 'Pick a size for the ' + what + '.';
        err.hidden = false;
        throw new Error('Pick a size for the ' + what + ' in the bundle above.');
      }
      if (!v.available) throw new Error('That ' + what + ' is sold out in that colour and size. Pick another.');
      return { id: v.id, quantity: 1 };
    }

    // The bundle choice stays selected after adding, like Kaching.
    reset() {}
  }

  if (!customElements.get('pp-pair')) customElements.define('pp-pair', PPPair);

  /* ---------- Temple / Map dropdown (snippets/pp-place.liquid) ---------- */

  // Every available product of the same type and design kind; picking one opens it with
  // the shopper's colour and size. Replaces the Easify dropdown (15 Oct 2026).
  class PPPlace extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.select = this.querySelector('[data-pp-place-select]');
      this.select.addEventListener('change', () => this.go(this.select.value));
      // Back button: the browser can restore this page mid-navigation, disabled.
      window.addEventListener('pageshow', () => {
        this.select.disabled = false;
        this.select.value = this.dataset.handle;
      });
      loadCatalog().then((all) => this.fill(toList(all, this.dataset.type))).catch(() => {});
    }

    fill(list) {
      var mine = this.dataset.handle;
      var items = list.filter((x) => x.k === this.dataset.kind);
      if (!items.length) return;
      // The list holds available products only, so a sold-out page is not in it: keep the
      // server's option for it, selected, ahead of the others.
      var current = items.some((x) => x.h === mine) ? null : this.select.querySelector('option[value="' + mine + '"]');
      this.select.innerHTML = '';
      if (current) this.select.appendChild(current);
      items.forEach((x) => {
        var o = document.createElement('option');
        o.value = x.h;
        o.textContent = x.n;
        this.select.appendChild(o);
      });
      this.select.value = mine;
    }

    // The page's option values by name, read from the theme's own picker for this section.
    picked() {
      var out = {};
      var vs = (this.dataset.section && document.querySelector('variant-selects[data-section="' + this.dataset.section + '"]')) ||
        document.querySelector('variant-selects');
      if (!vs) return out;
      var bare = (n) => n.replace(/^options\[(.+)\]$/, '$1');
      vs.querySelectorAll('input[type="radio"]:checked').forEach((r) => { out[bare(r.name)] = r.value; });
      vs.querySelectorAll('select').forEach((s) => { out[bare(s.name)] = s.value; });
      return out;
    }

    go(handle) {
      if (handle === this.dataset.handle) return;
      var want = this.picked();
      var base = '/products/' + handle;
      this.select.disabled = true;
      fetch(base + '.js')
        .then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then((p) => {
          var names = p.options.map((o) => (typeof o === 'string' ? o : o.name));
          var fits = (v) => names.every((n, i) => !want[n] || v.options[i] === want[n]);
          var v = p.variants.find((x) => fits(x) && x.available) || p.variants.find(fits) ||
            p.variants.find((x) => x.available);
          window.location.href = v ? base + '?variant=' + v.id : base;
        })
        .catch(() => { window.location.href = base; });
    }
  }

  if (!customElements.get('pp-place')) customElements.define('pp-place', PPPlace);

  /* ---------- one Add to cart for everything the shopper picked ---------- */

  function partsFor(form) {
    // getAttribute, not form.id: the form holds an <input name="id">, which shadows form.id.
    var formId = form && form.getAttribute && form.getAttribute('id');
    if (!formId || formId.indexOf('product-form-') !== 0) return null;
    var section = formId.replace('product-form-', '');
    var bundle = document.querySelector('pp-bundle[data-section="' + section + '"]');
    var pair = document.querySelector('pp-pair[data-section="' + section + '"]');
    var active = (bundle && bundle.isActive()) || (pair && pair.isActive());
    return active ? { bundle: bundle, pair: pair } : null;
  }

  function collectItems(form, parts) {
    var data = new FormData(form);
    var props = {};
    data.forEach((value, key) => {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && typeof value === 'string' && value !== '') props[m[1]] = value;
    });
    var counts = {};
    var order = [];
    var add = (id, n) => {
      if (!counts[id]) { counts[id] = 0; order.push(id); }
      counts[id] += n;
    };
    add(parseInt(data.get('id'), 10), parseInt(data.get('quantity'), 10) || 1);
    if (parts.bundle) parts.bundle.tierIds().forEach((id) => add(id, 1));
    // Easify's fields describe this product, so they go on its lines only.
    var items = order.map((id) => {
      var item = { id: id, quantity: counts[id] };
      if (Object.keys(props).length) item.properties = props;
      return item;
    });
    if (parts.pair && parts.pair.isActive()) items.push(parts.pair.item());
    var art = parts.bundle ? parts.bundle.artId() : null;
    if (art) items.push({ id: art, quantity: 1 });
    return items;
  }

  function submitAll(form, parts, ownButton, toCheckout, waited) {
    var host = form.closest('product-form');
    var errorWrap = host && host.querySelector('.product-form__error-message-wrapper');
    var errorText = errorWrap && errorWrap.querySelector('.product-form__error-message');
    var showError = (msg) => { if (errorWrap) { errorText.textContent = msg; errorWrap.hidden = false; } };
    var button = ownButton || form.querySelector('[type="submit"][name="add"], [type="submit"]');
    if (errorWrap) errorWrap.hidden = true;
    // A design that failed to load gets another try when Add to cart is pressed.
    if (!waited && parts.pair && parts.pair.isActive() && parts.pair.failed && parts.pair.failed === parts.pair.place.value) {
      parts.pair.load(parts.pair.failed);
    }
    // The other item's list or the picked design is still loading: wait (once, up to 8 s).
    if (!waited && parts.pair && parts.pair.isActive() && (!parts.pair.product || parts.pair.pending)) {
      if (button) { button.classList.add('loading'); button.setAttribute('aria-disabled', 'true'); }
      var until = parts.pair.pending ? parts.pair.pendingPromise : parts.pair.ready;
      Promise.race([until, new Promise((r) => setTimeout(r, 8000))]).then(() => {
        if (button) { button.classList.remove('loading'); button.removeAttribute('aria-disabled'); }
        submitAll(form, parts, ownButton, toCheckout, true);
      });
      return;
    }
    var items;
    try {
      items = collectItems(form, parts);
    } catch (err) {
      showError(err.message);
      if (parts.pair) parts.pair.reset();
      return;
    }
    if (button) { button.classList.add('loading'); button.setAttribute('aria-disabled', 'true'); }
    postCart('/cart/add.js', { items: items })
      .then((state) => {
        // Buy it now: same items, then straight to checkout instead of the drawer.
        if (toCheckout) { window.location.href = '/checkout'; return; }
        state.id = items[0].id;
        renderCart(state);
        if (parts.bundle) parts.bundle.reset();
        if (parts.pair) parts.pair.reset();
      })
      .catch((err) => showError(err.message))
      .finally(() => {
        if (parts.pair) parts.pair.reset();
        if (button) { button.classList.remove('loading'); button.removeAttribute('aria-disabled'); }
      });
  }

  // Path 1: the form's own submit (main Add to cart button). Capture runs before
  // Shrine's bound listener on the form.
  document.addEventListener('submit', function (e) {
    var parts = partsFor(e.target);
    if (!parts) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submitAll(e.target, parts);
  }, true);

  // Path 2: buttons elsewhere (sticky bar, section buttons) call handleSubmit directly.
  var ProductForm = customElements.get('product-form');
  if (ProductForm && ProductForm.prototype.handleSubmit && !ProductForm.prototype._ppWrapped) {
    var original = ProductForm.prototype.handleSubmit;
    ProductForm.prototype.handleSubmit = function (e) {
      var parts = partsFor(this.form);
      if (parts) {
        if (e && e.preventDefault) e.preventDefault();
        var src = e && (e.currentTarget || e.target);
        var buyNow = !!(src && src.closest && src.closest('[data-skip-cart-button]'));
        submitAll(this.form, parts, buyNow ? src.closest('[data-skip-cart-button]') : null, buyNow);
        return;
      }
      return original.apply(this, arguments);
    };
    ProductForm.prototype._ppWrapped = true;
  }

  /* ---------- cart drawer Art File add-on ---------- */

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-pp-cart-art]');
    if (!box) return;
    var id = parseInt(box.dataset.ppCartArt, 10);
    var row = box.closest('.pp-cart-art__row');
    if (row) row.classList.add('is-loading');
    var request = box.checked
      ? postCart('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
      : postCart('/cart/change.js', { id: String(id), quantity: 0 });
    request
      .then(function (state) { renderCart(state); })
      .catch(function () {
        box.checked = !box.checked;
        if (row) row.classList.remove('is-loading');
      });
  });
})();
